/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Publisher, CDN/CO2, and creative-scan widgets used on analysis pages.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../app-shared.module';
import {AdnSelectComponent} from '../directives/adn-select/adn-select.component';
import {Co2StatsComponent} from './co2-stats.component';
import {CdnStatsComponent} from './cdn-stats.component';
import {FloorPriceComponent} from './floor-price.component';
import {PublisherInfoComponent} from './publisher-info.component';
import {InactiveTargetsComponent} from './inactive-targets.component';
import {ScannedCreativesComponent} from './scanned-creatives.component';
import {ExternalAdUnitsComponent} from '../directives/external-ad-units.component';

const PUBLISHER_STATS = [
  Co2StatsComponent,
  CdnStatsComponent,
  FloorPriceComponent,
  PublisherInfoComponent,
  InactiveTargetsComponent,
  ScannedCreativesComponent,
  ExternalAdUnitsComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    AdnSelectComponent
  ],
  declarations: PUBLISHER_STATS,
  exports: PUBLISHER_STATS
})
export class PublisherStatsModule {
}
